

// EmployeePinValidation.jsx
import React, { useState, useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { login, logout} from "../features/auth/authSlice";
import PinEntry from './PinEntry';

const EmployeePinValidation = ({ email }) => {
    const [pin, setPin] = useState('');
    const { user, isSuccessAuth } = useSelector((state) => state.auth);
    const dispatch = useDispatch();

  const handleOnCompletePin = (value) => {
    setPin(value);
    const userData = {
        email:email,
        password:value,
    };
    dispatch(login(userData));
  };


  return (
    <div>
        <PinEntry handleOnCompletePin={handleOnCompletePin} />
    </div>
  );
};

export default EmployeePinValidation;